export default __webpack_public_path__ + "static/media/product-detail-image-4.90240c1f.svg";